import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface BackdropProps {
  onClick?: VoidFunction;
  className?: string;
  children?: ReactNode;
  blurred?: boolean;
}

export function Backdrop({
  onClick,
  className,
  children,
  blurred,
}: BackdropProps) {
  return (
    <div
      onClick={onClick}
      className={twMerge(
        "absolute inset-0",
        blurred
          ? "z-10 flex items-center justify-center bg-white/60 backdrop-blur-[1px]"
          : "bg-black/60",
        className,
      )}
    >
      {children}
    </div>
  );
}
